module.exports = __webpack_public_path__ + "image-1c407fe00675.png";